import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { AdminBloqueoAll } from './components/AdminBloqueoAll';

export default function AdminBloqueo() {
  return (
    <>
      <MainContent
        titulo='Administración de Bloqueos'
        component={<AdminBloqueoAll />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}